export const phraseLinkClassName = 'phrase-link';
